import React from "react";
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { cloneArray, isDefined, sortReactTable } from '../../../utils';
import ZSearch from '../../Common/ZSearch';

const likertScales = [
    {
        id: 1,
        name: 'Level of Acceptability',
        choices: [
            {
                id: 1,
                value: 'Totally unacceptable'
            }, {
                id: 2,
                value: 'Unacceptable'
            }, {
                id: 3,
                value: 'Slightly unacceptable'
            },
            {
                id: 4,
                value: 'Neutral'
            },
            {
                id: 5,
                value: 'Slightly acceptable'
            },
            {
                id: 6,
                value: 'Acceptable'
            },
            {
                id: 7,
                value: 'Perfectly Acceptable'
            }]
    }, {
        id: 2,
        name: 'Knowledge of Action',
        choices: [
            {
                id: 1,
                value: 'Never true'
            }, {
                id: 2,
                value: 'Rarely true'
            }, {
                id: 3,
                value: 'Sometimes but infrequently true'
            },
            {
                id: 4,
                value: 'Neutral'
            },
            {
                id: 5,
                value: 'Sometimes true'
            },
            {
                id: 6,
                value: 'Usually true'
            },
            {
                id: 7,
                value: 'Always true'
            }]
    },
    {
        id: 3,
        name: 'Level of Appropriateness',
        choices: [
            {
                id: 1,
                value: 'Absolutely inappropriate'
            }, {
                id: 2,
                value: 'Inappropriate'
            }, {
                id: 3,
                value: 'Slightly inappropriate'
            },
            {
                id: 4,
                value: 'Neutral'
            },
            {
                id: 5,
                value: 'Slightly appropriate'
            },
            {
                id: 6,
                value: 'Appropriate'
            },
            {
                id: 7,
                value: 'Absolutely appropriate'
            }]
    },
    {
        id: 4,
        name: 'Level of importance',
        choices: [
            {
                id: 1,
                value: 'Not at all important'
            }, {
                id: 2,
                value: 'Low importance'
            }, {
                id: 3,
                value: 'Slightly important'
            },
            {
                id: 4,
                value: 'Neutral'
            },
            {
                id: 5,
                value: 'Moderately important'
            },
            {
                id: 6,
                value: 'Very important'
            },
            {
                id: 7,
                value: 'Extremely important'
            }]
    },
];

class SelectLikertScaleType extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOptions: [],
            searchLikertScaleQuery: undefined,
        };
        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);

        this.onSearchLikertScale = this.onSearchLikertScale.bind(this);

        this.getScaleNode = this.getScaleNode.bind(this);
        this.getScalesNode = this.getScalesNode.bind(this);
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside(event) {
        const
            {
                onClose
            } = this.props;

        if (this.wrapperRef) {
            if (!this.wrapperRef.current.contains(event.target)) {
                onClose();
            }
        }
    }

    onSearchLikertScale({ target }) {
        this.setState({ searchLikertScaleQuery: target.value });
    }

    getScaleNode(scale) {
        const
            {
                onClose
            } = this.props;
        const choices = scale.choices.map(c => <div key={c.id}>{c.id} - {c.value}</div>);
        return (<div className="frame-1000001446">
            <div className="flex-container">
                <div>
                    {scale.name}
                </div>
                <div className="v3-button use-likert-scale flex-container-center" onClick={() => onClose(scale)}>
                    use it
                </div>
            </div>
            <hr />
            {choices}
        </div>);

    }

    getScalesNode() {


        //if (isDefined(this.state.searchLikertScaleQuery) && this.state.searchLikertScaleQuery != '') {
        //    result.data = result.data.filter(a => a.name.toLowerCase().includes(this.state.searchLikertScaleQuery.toLowerCase()));
        //}

        const scale0 = this.getScaleNode(likertScales[0]);
        const scale1 = this.getScaleNode(likertScales[1]);
        const scale2 = this.getScaleNode(likertScales[2]);
        const scale3 = this.getScaleNode(likertScales[3]);

        return (<div>
            <div className="flex-container-center">
                {scale0}
                {scale1}
            </div>
            <div className="flex-container-center">
                {scale2}
                {scale3}
            </div>
        </div>);
    }

    render() {
        const scalesNode = this.getScalesNode();
        return <div ref={this.wrapperRef}>
            <div>
                <div style={{ marginBottom: '10px' }}>
                    <ZSearch placeHolder="Search..." searchValue={this.state.searchLikertScaleQuery} onChange={this.onSearchLikertScale} />
                </div>
            </div>
            <div>
                {scalesNode}
            </div>
        </div>;
    };
}

const select = state => ({});
export default connect(select)(SelectLikertScaleType);

